export default __webpack_public_path__ + "static/media/org_level.7d5092fc.svg";